<script>
export default {
    components: {
        TransferSelect: {
            props: {
                value: String,
                delivery: Boolean, // 转岗
                positionList: {
                    type: Array,
                    default: () => []
                },
            },
            methods: {
                handleInput(v) {
                    if (this.value === v) return
                    this.$confirm('转岗将结束当前应聘流程，并生成新的应聘流程', '是否确认转岗？', {
                        distinguishCancelAndClose: true,
                    })
                        .then(() => {
                            this.$listeners.input instanceof Function && this.$listeners.input(v)
                            this.$refs.recommendSelect && this.$refs.recommendSelect.handleClose()
                        })
                        .catch(() => {})
                }
            },
            computed: {
                selectListeners() {
                    return this.delivery ? Object.assign({}, this.$listeners, {
                        input: this.handleInput.bind(this)
                    }) : this.$listeners
                }
            },
            render() {
                return <el-select
                    class="recommend-select"
                    filterable
                    placeholder="请输入"
                    value={this.value}
                    ref="recommendSelect"
                    {...{ attrs: this.$attrs, on: this.selectListeners }}
                >
                    {(this.positionList || []).map(item => <el-option
                        class="recommend-select-option"
                        key={item.value}
                        value={item.value}
                        label={item.text}
                    >
                        <p class="recommend-select-text">{item.text}</p>
                        {
                            item.additionData && item.additionData.followUpWorkCode && 
                            <span>
                                负责HR：{ item.additionData.followUpName }（{ item.additionData.followUpWorkCode }）
                            </span>
                        }
                    </el-option>)}
                </el-select>
            }
        }
    }
}
</script>

<style lang="scss">
    .recommend-select {
        &-option {
           display: flex;
           justify-content:space-between; 
        }
        &-text {
            max-width: 400px;
            overflow: hidden;
            text-overflow:ellipsis;
        }
    }
</style>



// WEBPACK FOOTER //
// jobTransfer.vue?0599aeb8